import { Component, Inject, OnInit, ViewChild, EventEmitter } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { MessageObservableService } from '../../../../../../services/message-observable.service';
import { DValorDominio } from '@dian/api-basicos-parametricas';
import { DTasaCambioCompleto, DTasaCambioSimple } from '@dian-api/renta210v18';
import { timer } from 'rxjs/observable/timer';
import { ComponentFactoryService } from '../../../../../../services/component-factory.service';
import { RentasLiquidasGravablesComponent } from '../../impuesto-renta/rentas-liquidas-gravables-modal/rentas-liquidas-gravables-modal.component';

const VAL_INDICADOR_COMPLETO = "999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE = 'cs_id_166';

const stepsList = [
  { text: "1", active: false, completed: false, tooltip: 'Valor Bienes Muebles Leasing', listHelp: ['165'] }
];
const tableStructure = [
  { id: 'desc', title: 'Descripción' },
  { id: 'textoUbicacion', title: 'Ubicación del activo' },
  // { id: 'valCompra', title: 'Valor de compra' },
  // { id: 'valMonedaExtranjera', title: 'Valor moneda extranjera' },
  // { id: 'moneda', title: 'Moneda' },
  { id: 'valorCOP', title: 'Valor a declarar' },
];

class ArticulosDominio {
  valor: number;
  nombre: string;
}

class Form1 {
  id: number;
  desc: string;//desc
  ubicacion: string;//ubicacion
  textoUbicacion: string;//textoUbicacion
  fechaAdquisicion: string = '20231231';//fecha adquisición
  valCompra: string;//valCompra
  valMonedaExtranjera: string;//valMonedaExtranjera
  moneda: string;//moneda
  valorCOP: string;//valorCOP valor en pesos
  valDeclarar: string;//valDeclarar
  trmCOP: number = 3822.05;
}


class MonedasDominio {
  valor: string;
  nombre: string;
}
@Component({
  selector: 'app-patrimonio-activos-omitidos-modal',
  templateUrl: './patrimonio-activos-omitidos-modal.component.html',
  styleUrls: ['./patrimonio-activos-omitidos-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio,
    DValorDominio,
    ComponentFactoryService
  ]
})
export class PatrimonioActivosOmitidosModalComponent extends HandlerModal implements OnInit {
  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  public lstArticulos: ArticulosDominio[] = [];
  public OPERACION_NULA: number = 0;
  public OPERACION_AGREGAR: number = 1;
  public OPERACION_EDITAR: number = 2;
  public OPERACION_BORRAR: number = 3;
  public operacionTabla: number = this.OPERACION_NULA;
  public precargaProceso;
  public precargaProceso2;
  public listaMoneda: DValorDominio[] = [];

  @ViewChild('buttonRight') buttonRight: any;
  saveModel = new EventEmitter();
  getTRM = new EventEmitter();

  public showSave: boolean;

  constructor(
    public dutilidades: DOperacionesMatematicasServicio,
    public dNotificacionServicio: DNotificacionServicio,
    public dialogRef: MatDialogRef<PatrimonioActivosOmitidosModalComponent>,
    private _messagesObs: MessageObservableService,
    private _componentFactory: ComponentFactoryService,

    @Inject(MAT_DIALOG_DATA) public model: DDocumento
  ) {
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    console.log(model);
  }

  ngOnInit() {
    this.initializeMonedas();
    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();

    /*  this.validateBtnRightActive();
     this.validateShowSave(); */
    this.listenMessagesObs();

  }

  protected inicializeForm() {
    this.modelForm = new Form1();
    this.modelForm.id = 0;
    this.modelForm.desc = "";
    this.modelForm.fechaAdquisicion = "20231231";
    this.modelForm.valCompra = "0";
    this.modelForm.ubicacion = "1";
    this.modelForm.textoUbicacion = "Colombia";
    this.modelForm.valorCOP = "0";
    this.modelForm.valDeclarar = "0";
    this.modelForm.moneda = "";
    this.modelForm.trmCOP = 0;
    this.reloadSelArticulos();

  }









  protected inicializeModelo() {
    if (this.model.doc.cuerpo.cc_id_243 == undefined) {

      this.model.doc.cuerpo.cc_id_243 = [];  //  243	Descripción
      this.model.doc.cuerpo.cc_id_244 = [];  //  244	Ubicación Activos
      this.model.doc.cuerpo.cc_id_245 = [];  //  245	Valor
      this.model.doc.cuerpo.cc_id_246 = [];  //  246	Tipo de moneda
      this.model.doc.cuerpo.cc_id_247 = [];  //  247	Valor en la moneda
      this.model.doc.cuerpo.cc_id_248 = [];  //  248	Valor a declarar  31-12-2023
      this.model.doc.cuerpo.cs_id_166 = this.model.doc.cuerpo.cs_id_166?this.model.doc.cuerpo.cs_id_166:"0";  //  166	Total de activos omitidos en periodos anteriores

    }
  }
  protected initializeMonedas() {
  }
  protected reloadSelArticulos(conservarArt?: boolean) {//Dom 1649

    this.lstArticulos[0] = { valor: 1, nombre: "Colombia" };
    this.lstArticulos[1] = { valor: 2, nombre: "Exterior" };

    // if (!conservarArt) this.modelForm.valorCOP = "0";
  }

  protected initializeTablaDesdeModelo() {
    this.dataSourceBody = [];
    for (let i = 0; i < this.model.doc.cuerpo.cc_id_243.length; i++) {
      this.modelForm.id = i;
      this.modelForm.desc = this.model.doc.cuerpo.cc_id_243[i].v;  //  243	Descripción
      this.modelForm.ubicacion = this.model.doc.cuerpo.cc_id_244[i].v;  //  244	Ubicación Activos
      this.modelForm.valCompra = this.model.doc.cuerpo.cc_id_245[i].v;  //  245	Valor
      this.modelForm.moneda = this.model.doc.cuerpo.cc_id_246[i].v == '0' ? '' : this.model.doc.cuerpo.cc_id_246[i].v;  //  246	Tipo de moneda
      this.modelForm.valMonedaExtranjera = this.model.doc.cuerpo.cc_id_247[i].v;  //  247	Valor en la moneda
      this.modelForm.valorCOP = this.model.doc.cuerpo.cc_id_248[i].v;  //  248	Valor a declarar  31-12-2023
      if (this.lstArticulos && this.lstArticulos.length > 0) {
        this.modelForm.textoUbicacion = this.lstArticulos[Number(this.model.doc.cuerpo.cc_id_244[i].v) - 1].nombre;
      }
      // this.modelForm.fechaAdquisicion = this.model.doc.cuerpo.cc_id_249[i].v;

      this.dataSourceBody.push(this.modelForm);
      this.inicializeForm();
    }
    this.operacionCs166();
  }
  public editModeloDesdeForm() {
    this.model.doc.cuerpo.cc_id_243[this.modelForm.id - 1].v = this.modelForm.desc;//  243	Descripción
    this.model.doc.cuerpo.cc_id_244[this.modelForm.id - 1].v = this.modelForm.ubicacion;//  244	Ubicación Activos
    this.model.doc.cuerpo.cc_id_245[this.modelForm.id - 1].v = this.modelForm.valCompra;//  245	Valor
    this.model.doc.cuerpo.cc_id_246[this.modelForm.id - 1].v = this.modelForm.moneda;//  246	Tipo de moneda
    this.model.doc.cuerpo.cc_id_247[this.modelForm.id - 1].v = this.dutilidades.deshacerFormatoMoneda(this.modelForm.valMonedaExtranjera);//  247	Valor en la moneda
    this.model.doc.cuerpo.cc_id_248[this.modelForm.id - 1].v = this.modelForm.valorCOP;//  248	Valor a declarar  31-12-2023
    // this.model.doc.cuerpo.cc_id_249[this.modelForm.id - 1].v = this.modelForm.fechaAdquisicion.toString();


  }
  public addToModeloDesdeForm() {
    let i = this.modelForm.id + 1;
    this.model.doc.cuerpo.cc_id_243.push({ it: i, v: this.modelForm.desc });//  243	Descripción
    this.model.doc.cuerpo.cc_id_244.push({ it: i, v: this.modelForm.ubicacion });//  244	Ubicación Activos
    this.model.doc.cuerpo.cc_id_245.push({ it: i, v: this.modelForm.valCompra });//  245	Valor
    this.model.doc.cuerpo.cc_id_246.push({ it: i, v: this.modelForm.moneda });//  246	Tipo de moneda
    this.model.doc.cuerpo.cc_id_247.push({ it: i, v: this.dutilidades.deshacerFormatoMoneda(this.modelForm.valMonedaExtranjera) });//  247	Valor en la moneda
    this.model.doc.cuerpo.cc_id_248.push({ it: i, v: this.modelForm.valorCOP });//  248	Valor a declarar  31-12-2023
    // this.model.doc.cuerpo.cc_id_249.push({ it: i, v: this.modelForm.fechaAdquisicion.toString()}) ;

  }

  public deleteOnModel(index: number) {
    this.model.doc.cuerpo.cc_id_243.splice(index, 1);
    this.model.doc.cuerpo.cc_id_245.splice(index, 1);
    this.model.doc.cuerpo.cc_id_244.splice(index, 1);
    this.model.doc.cuerpo.cc_id_246.splice(index, 1);
    this.model.doc.cuerpo.cc_id_247.splice(index, 1);
    this.model.doc.cuerpo.cc_id_248.splice(index, 1);
    // this.model.doc.cuerpo.cc_id_249.splice(index, 1);


    //reenumerear it
    for (let i = 0; i < this.model.doc.cuerpo.cc_id_243.length; i++) {
      this.model.doc.cuerpo.cc_id_243[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_244[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_245[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_246[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_247[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_248[i].it = i + 1;
      // this.model.doc.cuerpo.cc_id_249[i].it = i + 1;
      // this.model.doc.cuerpo.cc_id_196[i].it=i+1;

    }
  }

  public validateFormCompleted(): boolean {
    if (this.modelForm.ubicacion) {
      if (this.modelForm.ubicacion == '1') {
        this.modelForm.fechaAdquisicion = "20231231";
        this.modelForm.moneda = "";
        this.modelForm.valMonedaExtranjera = "0";
        return this.modelForm.desc == undefined || this.modelForm.desc == null || this.modelForm.desc.trim() == "" ||        //desc
          this.modelForm.ubicacion == undefined || /* this.modelForm.ubicacion=="0" ||  */        //ubicacion
          this.modelForm.valCompra == undefined ||// this.modelForm.valCompra == "0" ||      //valCompra   
          this.modelForm.valMonedaExtranjera == undefined ||// this.modelForm.valMonedaExtranjera == "0" ||   //valorCOP     //moneda
          this.modelForm.valorCOP == undefined || this.modelForm.valorCOP == "0" || this.modelForm.valorCOP == ""
      }
      if (this.modelForm.ubicacion == '2') {
        this.modelForm.valCompra == "0"// this.modelForm.valCompra == "0" ||      //valCompra   

        return this.modelForm.desc == undefined || this.modelForm.desc == null || this.modelForm.desc.trim() == "" ||        //desc
          this.modelForm.ubicacion == undefined || /* this.modelForm.ubicacion=="0" ||  */        //ubicacion
          this.modelForm.fechaAdquisicion == undefined || this.modelForm.fechaAdquisicion == "" ||
          this.modelForm.valMonedaExtranjera == undefined ||// this.modelForm.valMonedaExtranjera == "0" ||   //valorCOP     //moneda
          this.modelForm.moneda == undefined || this.modelForm.moneda == "0" ||
          this.modelForm.valorCOP == undefined || this.modelForm.valorCOP == "0" || this.modelForm.valorCOP == ""
      }
    }
    return false;
    //valDeclarar

  }
  public redondearFormData() {
    this.modelForm.valCompra = this.modelForm.valCompra ? this.dutilidades.redondearValorMoneda(this.modelForm.valCompra.toString(), true) : "0";
    // this.modelForm.valMonedaExtranjera = this.modelForm.valMonedaExtranjera ? this.dutilidades.redondearValorMoneda(this.modelForm.valMonedaExtranjera.toString(), true) : "0";
    // this.modelForm.ubicacion=this.dutilidades.redondearValorMoneda(this.modelForm.ubicacion.toString(),true);

    // this.modelForm.moneda = this.dutilidades.redondearValorMoneda(this.modelForm.moneda.toString(), true);
    this.modelForm.valDeclarar = this.modelForm.valDeclarar ? this.dutilidades.redondearValorMoneda(this.modelForm.valDeclarar.toString(), true) : "0";

  }


  public calcularValoresForm(conservarArt?: boolean): void {
    if (this.modelForm.ubicacion != '1') {
      // Llamar a changeDataTRM y esperar a que termine
      this.precargaProceso2 = this.dNotificacionServicio.mostrarDialogoCarga();
      this.changeDataTRM().then(() => {

        setTimeout(() => {
          console.log('changeDataTRM: ha terminado de ejecutarse, TRM: ', this.modelForm.trmCOP);

          this.redondearFormData();
          this.modelForm.id = this.dataSourceBody.length;

          let valUbicacion = this.modelForm.ubicacion ? this.modelForm.ubicacion.toString() : "1";

          switch (valUbicacion) { //casilla 244
            case "1": //ubicación Colombia casilla 245 valCompra
              this.modelForm.valorCOP = this.modelForm.valCompra;
              break;
            case "2": //ubicación exterior
              this.modelForm.valCompra = "0";

              let resultado = this.dutilidades.ejecutarOperacion(
                DTipoOperacionAritmetica.MULTIPLICACION,
                this.modelForm.trmCOP.toString(),
                this.modelForm.valMonedaExtranjera,
                true
              );

              resultado = this.dutilidades.redondearValorMoneda(resultado.toString(), true);
              this.modelForm.valorCOP = resultado;
              break;
            default:
              break;
          }

          this.modelForm.valDeclarar = this.modelForm.valorCOP; // 248// Valor a declarar  31-12-2023
          this.reloadSelArticulos(conservarArt);
          if (this.precargaProceso2 != undefined) this.precargaProceso2.close();
        }, 1000);//Se requiere introducir retardo para que la TRM alcance a llenarse
      }).catch((error) => {
        console.error('Error en changeDataTRM:', error);
        // Manejo del error si es necesario
      });
    } else {
      this.modelForm.valMonedaExtranjera = '0';
      this.modelForm.valorCOP = this.dutilidades.obtenerFormatoMoneda(this.modelForm.valCompra);
    }
  }


  public async changeDataTRM(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        if (this.modelForm.moneda != undefined && this.modelForm.moneda != "" &&
          this.modelForm.fechaAdquisicion != undefined && this.modelForm.fechaAdquisicion != "" &&
          this.modelForm.moneda != "0") {

          let tasaCambioSolicitud: DTasaCambioSimple = new DTasaCambioSimple();
          tasaCambioSolicitud.moneda = this.modelForm.moneda;
          let tasaCambioCompleto: DTasaCambioCompleto = new DTasaCambioCompleto();
          let fecha = '20231231'; // this.modelForm.fechaAdquisicion.split("-").join("");

          if (fecha > "20231231") {
            let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe seleccionar una fecha menor o igual al 31 de diciembre de 2023");
            this.modelForm.fechaAdquisicion = "20231231";
            this.modelForm.trmCOP = 0;
            this.modelForm.valorCOP = "0";
            resolve();
            return;
          }

          if (fecha < "20161231") {
            fecha = "20161231";
          }

          tasaCambioCompleto.fecha = fecha;
          tasaCambioCompleto.tasaCambioSolicitud = tasaCambioSolicitud;

          this.getTRM.emit(tasaCambioCompleto);
          this.precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();

          // Suponiendo que `mostrarDialogoCarga` devuelva una promesa:
          await this.precargaProceso;
          resolve();
        } else {
          this.modelForm.trmCOP = 0;
          this.modelForm.valorCOP = "0";
          resolve();
        }
      } catch (error) {
        reject(error);
      }
    });
  }



  private listenMessagesObs() {//Recepcion de data del rest TRM
    this._messagesObs.getMessages().subscribe(res => {
      if (res.operation === 'trmCompleto') {
        if (this.precargaProceso != undefined) this.precargaProceso.close();
        if (res.message != null) {
          this.modelForm.trmCOP = res.message.tasaCambioSolicitud.valor;
          // this.calcularValoresForm();
        } else {
          this.modelForm.trmCOP = 0;
          this.modelForm.valorCOP = "0";
        }
        if (this.modelForm.trmCOP == 0) {
          let dialogError = this.dNotificacionServicio.mostrarDialogoInformacion("No se encontraron datos para la moneda seleccionada, se recomienda realizar la conversión a USD");
        }
      }
    });
  }
  saveItem(): void {
    if (this.validateFormCompleted()) {
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro");
      return;
    } else {
      this.redondearFormData();
      if (this.operacionTabla == this.OPERACION_EDITAR) {
        // this.editModeloDesdeForm();
      } else if (this.operacionTabla == this.OPERACION_AGREGAR) {
        this.modelForm.id = this.dataSourceBody.length;
        if (this.lstArticulos && this.lstArticulos.length > 0) {
          this.modelForm.textoUbicacion = this.lstArticulos[Number(this.modelForm.ubicacion) - 1].nombre;
        }
        this.dataSourceBody.push(this.modelForm);
        this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      this.operacionCs166();
      this.inicializeForm();
      this.operacionTabla = this.OPERACION_NULA;
      console.log(this.model);
    }
  }

  eventTable($event: string): void {
    if ($event === 'add') this.operacionTabla = this.OPERACION_AGREGAR;
    if ($event === 'edit') this.operacionTabla = this.OPERACION_EDITAR;
    if ($event === 'delete') this.operacionTabla = this.OPERACION_BORRAR;
    this.operacionCs166();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if (this.operacionTabla == this.OPERACION_EDITAR) {//editando
      this.modelForm = this.dataSourceBody[index];
      this.reloadSelArticulos(true);
    }
    if (this.operacionTabla == this.OPERACION_BORRAR) {//borrando
      this.deleteOnModel(index);
      this.operacionTabla = this.OPERACION_NULA;
    }
  }

  cancel(): void {
    this.inicializeForm();
    this.operacionTabla = this.OPERACION_NULA;
  }



  public operaciones(numCas?: number, soloEstaCasilla?: boolean): void {
    switch (numCas) {
      case 152:
        this.operacionCs166();
        break;
    }
    if (soloEstaCasilla) return;

    //Operaciones
    let resultado = "0";

    //C151=C149-C153+C154+C155; 
    resultado = "0";
    resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, this.model.doc.cuerpo.cs_id_149, this.model.doc.cuerpo.cs_id_153, true);
    resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resultado, this.model.doc.cuerpo.cs_id_154, true);
    resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resultado, this.model.doc.cuerpo.cs_id_155, true);
    resultado = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultado, "0") ? "0" : resultado;
    this.model.doc.cuerpo.cs_id_151 = this.dutilidades.redondearValorMoneda(resultado, true);

  }

  operacionCs166() {
    let suma = "0";
    for (let i = 0; i < this.dataSourceBody.length; i++) {
      suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.dataSourceBody[i].valorCOP, suma);
    }
    this.model.doc.cuerpo.cs_id_166 = suma;

  }

  protected obtenerCasIndicadorAvance(): string {
    if (this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] == undefined) {
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] = "0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }



  protected controlStep(direction: DirectionType): void {

  }



  public closeModal() {
    this.initializeTablaDesdeModelo();
    this.operacionCs166();
    this.dialogRef.close("");
  }

  public guardar() {

    this.model.doc.cuerpo.cc_id_243 = undefined;
    this.inicializeModelo();
    for (let i = 0; i < this.dataSourceBody.length; i++) {
      this.modelForm = this.dataSourceBody[i];
      this.addToModeloDesdeForm();
    }


    this.operacionCs166();
    this.saveModel.emit(true);



    this.closeModal();
    console.log('modelo en activos omitidos: ', this.model);
  }



}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/patrimonio/patrimonio-activos-omitidos-modal/patrimonio-activos-omitidos-modal.component.ts